import { render, staticRenderFns } from "./TipoCarri.vue?vue&type=template&id=f34eb764"
import script from "./TipoCarri.vue?vue&type=script&lang=js"
export * from "./TipoCarri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports